import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/scorecard/public-assessment.tsx");
